// @ts-nocheck
import { Column } from 'react-table'
import { TitleCell } from './TitleCell'
import { UserCustomHeader } from './CustomHeader'
import { ActionCell } from './ActionCell'
import { NumberCell } from './NumberCell'

const subscriptionTiersColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Name"
        className="min-w-100px"
      />
    ),
    id: "name",
    Cell: ({ ...props }) => (
      <TitleCell userObj={props.data[props.row.index]?.name} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Slug"
        className="min-w-80px"
      />
    ),
    id: "slug",
    Cell: ({ ...props }) => (
      <TitleCell userObj={props.data[props.row.index]?.slug} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Price (EGP)"
        className="min-w-80px"
      />
    ),
    id: "priceEgp",
    Cell: ({ ...props }) => (
      <NumberCell userObj={props.data[props.row.index]?.priceEgp} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="First-Time Price"
        className="min-w-80px"
      />
    ),
    id: "firstTimePrice",
    Cell: ({ ...props }) => (
      <TitleCell userObj={props.data[props.row.index]?.firstTimePrice ?? "—"} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Credits/Cycle"
        className="min-w-80px"
      />
    ),
    id: "creditsPerCycle",
    Cell: ({ ...props }) => (
      <NumberCell userObj={props.data[props.row.index]?.creditsPerCycle} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Cycle Days"
        className="min-w-60px"
      />
    ),
    id: "cycleDays",
    Cell: ({ ...props }) => (
      <NumberCell userObj={props.data[props.row.index]?.cycleDays} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Active"
        className="min-w-50px"
      />
    ),
    id: "isActive",
    Cell: ({ ...props }) => (
      <TitleCell userObj={props.data[props.row.index]?.isActive ? "Yes" : "No"} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Action"
        className="min-w-75px"
      />
    ),
    id: "action",
    Cell: ({ ...props }) => <ActionCell user={props.data[props.row.index]} />,
  },
];

export { subscriptionTiersColumns }
